import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiZod } from '@/shared/api'
import { type Recording, RecordingSchema } from '../model/schema'
import { toRecording } from './mappers'

export const recordingKeys = {
  all: ['recording'] as const,
  detail: (id: string) => [...recordingKeys.all, id] as const,
}

export function recordingQueryOptions(id: string) {
  return queryOptions({
    queryKey: recordingKeys.detail(id),
    queryFn: async (): Promise<Recording> => {
      const body = await apiGet(`/meetings/${id}/recording`, apiZod.zGetRecordingResponse)
      return RecordingSchema.parse(toRecording(body.data))
    },
    // Пока запись активна — опрашиваем; готовую/упавшую не дёргаем.
    refetchInterval: (query) => (query.state.data?.state === 'recording' ? 5000 : false),
  })
}
